export const COLOR = {
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  BLACK1: "#99A1B7",
  BLACK2: "#2D3142",
  GRAY: "#FAFAFA",
  GRAY1: "#79747E",
  GRAY2: "#9CA3AF",
  GRAY3: "#373A3C",
  GRAY4: "#071437",
};
export const IMAGE = {
  CONTACT: require("../Assets/NewImage/contact.png"),
  PHONE: require("../Assets/NewImage/phone.png"),
  EMAIL: require("../Assets/NewImage/mail.png"),
  IDCARD: require("../Assets/NewImage/cardId.png"),
  LOCATION: require("../Assets/NewImage/location.png"),
  NOIMAGE: require("../Assets/NewImage/NoImage.png"),
  EDIT: require("../Assets/NewImage/edit.png"),
  PEN: require("../Assets/NewImage/pen.png"),
  BACKGROUND: require("../Assets/NewImage/background.png"),
  LATE: require("../Assets/NewImage/late.png"),
  CAKE: require("../Assets/NewImage/cake.png"),
  LEAVE: require("../Assets/NewImage/calender.png"),
  PROFILE: require("../Assets/NewImage/profile.png"),
  MEDAL: require("../Assets/NewImage/medal.png"),
  GURUGRAM: require("../Assets/NewImage/gurugram.png"),
  NOIDA: require("../Assets/NewImage/noida.png"),
  CURRENT: require("../Assets/NewImage/current.png"),
};
export const FONT = {
  INTER: `"Noto Sans", sans-serif`,
};
